import type { ILoginService } from '../login.service';
import type { IAuthRoute, MethodType } from '../login.types';
import type { IController, IScope } from 'angular';
import { AVAILABLE_RENDER_FROM } from '../login.constants';
import { MODAL_STEP_CHANGED } from '../../../_common/modal/constant/modalConstant';
export type { ILoginStatus, ILoginStep, LoginSteps } from './loginStatus.controller';
export interface ILoginController extends IController {
  method?: string;
  authModuleId: string | null;
  authModules: IAuthModule[];
  showAuthRoutes: boolean;
  authRoutes: IAuthRoute[];
  title: string;
  description?: string;
  showBack: boolean;
  loaded: boolean;
  redirectTo?: string;
  isLanding?: boolean;
  lpId?: number;
  showAuthMethods: boolean;
  renderFrom?: RenderFrom;
  phone: string;
  email: string;
  privacyNotice?: string;
  changeMethod(method: string, moduleId: string): void;
  setAllAuthModuleIds(): void;
  back(method?: MethodType): void;
}
export interface IAuthModule {
  id: string;
  controllerName: string;
}
export type RenderFrom = typeof AVAILABLE_RENDER_FROM[number];
function assertsRenderFrom(value: unknown): asserts value is RenderFrom {
  if (typeof value !== 'string' || !AVAILABLE_RENDER_FROM.includes(value as RenderFrom)) throw new Error(`renderFrom '${String(value)}' not contains in AVAILABLE_RENDER_FROM`);
}
export default class LoginController implements ILoginController {
  method?: MethodType;
  authModuleId: string | null = null;
  authModules: IAuthModule[] = [];
  showAuthRoutes = true;
  authRoutes: IAuthRoute[] = [];
  title = '';
  description?: string;
  showBack = false;
  loaded = false;
  redirectTo?: string;
  isLanding?: boolean;
  lpId?: number;
  showAuthMethods = false;
  renderFrom?: RenderFrom;
  phone = '';
  email = '';
  privacyNotice?: string;

  /* @ngInject */
  constructor(readonly loginService: ILoginService, readonly $scope: IScope) {}
  $onInit() {
    this.loaded = true;
    if (typeof this.renderFrom !== 'undefined' && this.renderFrom !== null) {
      assertsRenderFrom(this.renderFrom);
    }
    this.watchStepLoading();
    this.loginService.getLoginPrivacyNotice().then(privacyNotice => {
      this.privacyNotice = privacyNotice;
    });
    this.loginService.getDefaultMethod().then(method => this.method = method).then(() => {
      if (this.method === 'module') {
        this.loginService.getDefaultAuthModuleId().then(authModuleId => this.authModuleId = authModuleId);
      }
    }).then(() => this.loginService.getAuthRoutes()).then(authRoutes => {
      this.authRoutes = authRoutes;
      this.setAllAuthModuleIds();
    }).catch(() => this.method = 'email').finally(() => this.loaded = false);
  }
  watchStepLoading() {
    this.$scope.$watch(() => this.loaded, (loaded: boolean, wasLoaded: boolean) => {
      if (wasLoaded && !loaded) {
        this.$scope.$emit(MODAL_STEP_CHANGED);
      }
    });
  }
  changeMethod(method: MethodType, moduleId: string) {
    this.method = method;
    this.authModuleId = moduleId;
    this.title = '';
    this.description = undefined;
    this.showBack = false;
    this.loaded = true;
  }
  setAllAuthModuleIds() {
    this.authRoutes.forEach(route => {
      if (typeof route.ModuleId !== 'undefined' && route.ModuleId !== null && route.ModuleId !== '' && typeof route.ModuleControllerName !== 'undefined' && route.ModuleControllerName !== null && route.ModuleControllerName !== '' && !this.authModules.some(module => module.id === route.ModuleId)) {
        this.authModules.push({
          id: route.ModuleId,
          controllerName: route.ModuleControllerName
        });
      }
    });
  }
  back(method?: MethodType) {
    switch (method) {
      case 'email':
        this.$scope.$broadcast('backLoginEmail');
        break;
      case 'code':
        this.$scope.$broadcast('backLoginCode');
        break;
      case 'module':
        this.$scope.$broadcast(`backModule${this.authModuleId ?? ''}`);
        break;
      case undefined:
        break;
      default:
        {
          const exhaustiveCheck: never = method;
          throw new Error(`Unexpected method ${String(exhaustiveCheck)}`);
        }
    }
  }
}
LoginController.$inject = ["loginService", "$scope"];